import { Contact }              from '../types';
import env                      from '../env';
import { createCacheableFetch } from '@statflo/fetch';

const cachedFetch = createCacheableFetch<Contact>();

export default async function dncService(banId: string, token: string): Promise<Contact> {
    const endPoint = `${env.WEBAPP_HOST}v2/api/dnc?ban_id=${banId}`;
    const requestInit: RequestInit = {
        method: 'GET',
        headers: new Headers({
            authorization: `Bearer ${token}`
        }),
        mode: 'cors',
    };

    const contact = await cachedFetch(endPoint, requestInit);
    return contact;
}



// WEBPACK FOOTER //
// ./src/services/DncService.ts